<img [src]="getAssetPath()">